<div class="white-box" *ngIf="!isInitialised; else showChart">
  <div class="loading"></div>
</div>

<ng-template #showChart>
  <ng-container *ngIf="customer">
    <div class="reporting-chart-wrapper" [class.limited-view]="isInitialised && daysDifference === 0">
      <div class="reporting-filter" [ngClass]="{ hidden: isInitialised && daysDifference === 0 }">
        <div
          *ngFor="let item of filterOptions"
          [class.active]="filterConfig.timePeriod === GraphFilterTimePeriod[item]"
          (click)="setTimePeriod(GraphFilterTimePeriod[item], filterConfig.timePeriod)"
        >
          <span class="xs-only sm-only">{{ 'performance.time_period.short.' + GraphFilterTimePeriod[item] | translate }}</span>
          <span class="xs-hide sm-hide">{{ 'performance.time_period.' + GraphFilterTimePeriod[item] | translate }}</span>
        </div>
      </div>
      <p *ngIf="daysDifference > 0" class="reporting-info">
        {{ 'tooltip.reprotingUpdate.title' | translate: { date: endValues?.end_date } }}
        <app-ui-tooltip [content]="'tooltip.reprotingUpdate.p' | translate" size="small"></app-ui-tooltip>
      </p>

      <app-reporting-chart-line-chart
        *ngIf="daysDifference > 0"
        [data]="dataChart"
        [hideDepositsTransfers]="hideDepositsTransfers"
        [hideWithdrawals]="hideWithdrawals"
        [transactionsTypeDepositTransfer]="transactionsTypeDepositTransfer"
        [transactionsTypeWithdrawal]="transactionsTypeWithdrawal"
        [filterConfig]="filterConfig"
        [daysDifference]="daysDifference"
        [currency]="currentAccount.currency"
        [currentLang]="customer.language"
      >
      </app-reporting-chart-line-chart>
    </div>
    <div class="reporting-numbers" [hidden]="isInitialised && daysDifference === 0" [class.initialised]="isInitialised">
      <h2>{{ 'performance.table.headlineData' | translate: { month: lastPerformanceMonth } }}</h2>
      <div class="flex-row flex-space-between">
        <div>
          <div class="flex-row flex-space-between">
            <div class="flex-col-auto">
              {{ 'performance.table.performance_net' | translate }}
              <app-ui-tooltip
                [content]="'performance.table.tooltips.performance_net' | translate"
                color="yellow"
                size="small"
              ></app-ui-tooltip>
            </div>
            <div class="flex-col-right reporting-number">
              <p>{{ currentMonth.net_return | translatePercent: customer.language }}</p>
            </div>
          </div>
        </div>
        <div>
          <div class="flex-row flex-space-between">
            <div class="flex-col-auto">
              {{ 'performance.table.performance_gross' | translate }}
              <app-ui-tooltip
                [content]="'performance.table.tooltips.performance_gross' | translate"
                color="yellow"
                size="small"
              ></app-ui-tooltip>
            </div>
            <div class="flex-col-right reporting-number">
              <p>{{ currentMonth.gross_return | translatePercent: customer.language }}</p>
            </div>
          </div>
        </div>
        <div>
          <div class="flex-row flex-space-between">
            <div class="flex-col-auto grey">
              {{ 'performance.table.market_performance' | translate }}<br />
              <small>({{ 'performance.header.as_of' | translate: { date: endValues?.last_benchmark_date } }})</small>
              <app-ui-tooltip [content]="'performance.table.tooltips.market' | translate" color="yellow" size="small"></app-ui-tooltip>
            </div>
            <div class="flex-col-right reporting-number">
              <p class="grey">{{ currentMonth.benchmark_return | translatePercent: customer.language }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</ng-template>
